import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@remote/assets/img/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-03dc5ed8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-logo",
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_3 = { class: "footer-box" }
const _hoisted_4 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.00002 11C7.27616 11 7.50002 10.7761 7.50002 10.5V5.78166C7.50002 5.21676 6.79056 4.96488 6.43435 5.4033L5.61196 6.41547C5.43783 6.62979 5.4704 6.94469 5.68472 7.11883C5.89904 7.29296 6.21394 7.26038 6.38807 7.04607L6.50002 6.90829V10.5C6.50002 10.7761 6.72387 11 7.00002 11Z",
  fill: "#212429"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.49998 5.5C8.49998 5.22386 8.72384 5 8.99998 5C9.27613 5 9.49998 5.22386 9.49998 5.5V9.09171L9.61193 8.95393C9.78606 8.73962 10.101 8.70704 10.3153 8.88117C10.5296 9.05531 10.5622 9.37021 10.388 9.58453L9.56565 10.5967C9.20944 11.0351 8.49998 10.7832 8.49998 10.2183V5.5Z",
  fill: "#212429"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5Z",
  fill: "#212429"
}, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "28",
  height: "28"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6615 2.17021L24.3385 7.53497C24.7478 7.76192 25 8.18134 25 8.63524V19.3648C25 19.8187 24.7478 20.2381 24.3385 20.465L14.6615 25.8298C14.2522 26.0567 13.7478 26.0567 13.3385 25.8298L3.66155 20.465C3.25218 20.2381 3 19.8187 3 19.3648L3 8.63524C3 8.18134 3.25218 7.76192 3.66155 7.53497L13.3385 2.17021C13.7478 1.94326 14.2522 1.94326 14.6615 2.17021Z",
  fill: "#3F85FF"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11 14L13.8586 16.8586C13.9367 16.9367 14.0633 16.9367 14.1414 16.8586L17 14",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14 10V15",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10V14.5858L11.7071 13.2929C11.3166 12.9024 10.6834 12.9024 10.2929 13.2929C9.90237 13.6834 9.90237 14.3166 10.2929 14.7071L13.1515 17.5657C13.6201 18.0343 14.3799 18.0343 14.8485 17.5657L17.7071 14.7071C18.0976 14.3166 18.0976 13.6834 17.7071 13.2929C17.3166 12.9024 16.6834 12.9024 16.2929 13.2929L15 14.5858V10Z",
  fill: "#6A707C"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.1767 3.0448L23.8536 8.40956C23.9574 8.46712 24 8.55873 24 8.63524V19.3648C24 19.4413 23.9574 19.5329 23.8536 19.5904L14.1767 24.9552C14.0689 25.0149 13.9311 25.0149 13.8233 24.9552L4.14641 19.5904C4.0426 19.5329 4 19.4413 4 19.3648V8.63524C4 8.55873 4.0426 8.46712 4.14641 8.40956L13.8233 3.0448C13.9311 2.98507 14.0689 2.98507 14.1767 3.0448Z",
  stroke: "#61636F",
  "stroke-width": "2"
}, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<path d=\"M8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z\" fill=\"#212429\" data-v-03dc5ed8></path><path d=\"M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z\" fill=\"#212429\" data-v-03dc5ed8></path><path d=\"M11 9C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9Z\" fill=\"#212429\" data-v-03dc5ed8></path><path d=\"M6 8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8Z\" fill=\"#212429\" data-v-03dc5ed8></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 10.5463 13.6404 12.7751 11.6076 14H14.5C14.7761 14 15 14.2239 15 14.5C15 14.7761 14.7761 15 14.5 15C12.3333 15 10.1667 15 8 15ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z\" fill=\"#212429\" data-v-03dc5ed8></path>", 5)
const _hoisted_25 = [
  _hoisted_20
]
const _hoisted_26 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4156 11.8333C15.0725 11.8333 16.4156 10.4902 16.4156 8.83334C16.4156 7.17648 15.0725 5.83334 13.4156 5.83334C11.7588 5.83334 10.4156 7.17648 10.4156 8.83334C10.4156 10.4902 11.7588 11.8333 13.4156 11.8333ZM13.4156 9.83333C13.9679 9.83333 14.4156 9.38562 14.4156 8.83334C14.4156 8.28105 13.9679 7.83334 13.4156 7.83334C12.8634 7.83334 12.4156 8.28105 12.4156 8.83334C12.4156 9.38562 12.8634 9.83333 13.4156 9.83333Z\" fill=\"#6A707C\" data-v-03dc5ed8></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.5 21.7498C15.1569 21.7498 16.5 20.4067 16.5 18.7498C16.5 17.093 15.1569 15.7498 13.5 15.7498C11.8431 15.7498 10.5 17.093 10.5 18.7498C10.5 20.4067 11.8431 21.7498 13.5 21.7498ZM13.5 19.7498C14.0523 19.7498 14.5 19.3021 14.5 18.7498C14.5 18.1976 14.0523 17.7498 13.5 17.7498C12.9477 17.7498 12.5 18.1976 12.5 18.7498C12.5 19.3021 12.9477 19.7498 13.5 19.7498Z\" fill=\"#6A707C\" data-v-03dc5ed8></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.667 13.8328C11.667 15.4897 10.3238 16.8328 8.66699 16.8328C7.01014 16.8328 5.66699 15.4897 5.66699 13.8328C5.66699 12.176 7.01014 10.8328 8.66699 10.8328C10.3238 10.8328 11.667 12.176 11.667 13.8328ZM9.66699 13.8328C9.66699 14.3851 9.21928 14.8328 8.66699 14.8328C8.11471 14.8328 7.66699 14.3851 7.66699 13.8328C7.66699 13.2805 8.11471 12.8328 8.66699 12.8328C9.21928 12.8328 9.66699 13.2805 9.66699 13.8328Z\" fill=\"#6A707C\" data-v-03dc5ed8></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.5836 16.8327C20.2405 16.8327 21.5836 15.4895 21.5836 13.8327C21.5836 12.1758 20.2405 10.8327 18.5836 10.8327C16.9268 10.8327 15.5836 12.1758 15.5836 13.8327C15.5836 15.4895 16.9268 16.8327 18.5836 16.8327ZM18.5836 14.8327C19.1359 14.8327 19.5836 14.385 19.5836 13.8327C19.5836 13.2804 19.1359 12.8327 18.5836 12.8327C18.0313 12.8327 17.5836 13.2804 17.5836 13.8327C17.5836 14.385 18.0313 14.8327 18.5836 14.8327Z\" fill=\"#6A707C\" data-v-03dc5ed8></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4167 26.25C13.5661 26.25 13.7148 26.2473 13.8629 26.242C13.9079 26.2473 13.9536 26.25 14 26.25H23.3334C23.9777 26.25 24.5 25.7277 24.5 25.0833C24.5 24.439 23.9777 23.9167 23.3334 23.9167H20.61C23.6743 21.69 25.6667 18.0777 25.6667 14C25.6667 7.23451 20.1822 1.75 13.4167 1.75C6.6512 1.75 1.16669 7.23451 1.16669 14C1.16669 20.7655 6.6512 26.25 13.4167 26.25ZM13.4167 23.9167C18.8935 23.9167 23.3334 19.4768 23.3334 14C23.3334 8.52318 18.8935 4.08333 13.4167 4.08333C7.93986 4.08333 3.50002 8.52318 3.50002 14C3.50002 19.4768 7.93986 23.9167 13.4167 23.9167Z\" fill=\"#6A707C\" data-v-03dc5ed8></path>", 5)
const _hoisted_32 = [
  _hoisted_27
]
const _hoisted_33 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#3F85FF",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.8628 25.6587C13.7147 25.664 13.566 25.6667 13.4166 25.6667C6.65114 25.6667 1.16663 20.1821 1.16663 13.4167C1.16663 6.65117 6.65114 1.16666 13.4166 1.16666C20.1821 1.16666 25.6666 6.65117 25.6666 13.4167C25.6666 17.4943 23.6743 21.1067 20.6099 23.3333H23.3333C23.9776 23.3333 24.5 23.8557 24.5 24.5C24.5 25.1443 23.9776 25.6667 23.3333 25.6667H14C13.9536 25.6667 13.9078 25.6639 13.8628 25.6587ZM16.0416 8.45837C16.0416 9.90812 14.8663 11.0834 13.4166 11.0834C11.9668 11.0834 10.7916 9.90812 10.7916 8.45837C10.7916 7.00863 11.9668 5.83337 13.4166 5.83337C14.8663 5.83337 16.0416 7.00863 16.0416 8.45837ZM16.0416 18.375C16.0416 19.8248 14.8663 21 13.4166 21C11.9668 21 10.7916 19.8248 10.7916 18.375C10.7916 16.9253 11.9668 15.75 13.4166 15.75C14.8663 15.75 16.0416 16.9253 16.0416 18.375ZM15.7499 13.4167C15.7499 14.8665 16.9252 16.0417 18.3749 16.0417C19.8247 16.0417 20.9999 14.8665 20.9999 13.4167C20.9999 11.967 19.8247 10.7917 18.3749 10.7917C16.9252 10.7917 15.7499 11.967 15.7499 13.4167ZM8.45825 16.0417C7.0085 16.0417 5.83325 14.8665 5.83325 13.4167C5.83325 11.967 7.0085 10.7917 8.45825 10.7917C9.908 10.7917 11.0833 11.967 11.0833 13.4167C11.0833 14.8665 9.908 16.0417 8.45825 16.0417Z"
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H6.5C6.77614 5.5 7 5.72386 7 6C7 6.27614 6.77614 6.5 6.5 6.5H4C3.72386 6.5 3.5 6.27614 3.5 6Z",
  fill: "#212429"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14 12.5V5.5C14 4.94772 13.5523 4.5 13 4.5H9.85078C9.39664 4.5 8.95602 4.34544 8.60139 4.06174L6.92313 2.71913C6.74582 2.57728 6.52551 2.5 6.29844 2.5H3C2.44772 2.5 2 2.94772 2 3.5V12.5C2 13.0523 2.44772 13.5 3 13.5H13C13.5523 13.5 14 13.0523 14 12.5ZM3 1.5C1.89543 1.5 1 2.39543 1 3.5V12.5C1 13.6046 1.89543 14.5 3 14.5H13C14.1046 14.5 15 13.6046 15 12.5V5.5C15 4.39543 14.1046 3.5 13 3.5H9.85078C9.62371 3.5 9.4034 3.42272 9.22609 3.28087L7.54783 1.93826C7.1932 1.65456 6.75258 1.5 6.29844 1.5H3Z",
  fill: "#212429"
}, null, -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#6A707C",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.4083 6.14286C17.143 6.14286 16.8887 6.0375 16.7012 5.84996L14.1441 3.29289C13.9565 3.10536 13.7022 3 13.437 3H4.375C3.82272 3 3.375 3.44772 3.375 4V24C3.375 24.5523 3.82272 25 4.375 25H24.375C24.9273 25 25.375 24.5523 25.375 24V7.14286C25.375 6.59057 24.9273 6.14286 24.375 6.14286H17.4083ZM23.0702 9.44762C23.0702 8.89533 22.6225 8.44762 22.0702 8.44762H16.4536C16.1884 8.44762 15.934 8.34226 15.7465 8.15473L13.1894 5.59766C13.0019 5.41012 12.7475 5.30476 12.4823 5.30476H6.67976C6.12748 5.30476 5.67976 5.75248 5.67976 6.30476V21.6952C5.67976 22.2475 6.12748 22.6952 6.67976 22.6952H22.0702C22.6225 22.6952 23.0702 22.2475 23.0702 21.6952V9.44762Z"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#6A707C",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.375 11.1C7.375 10.4925 7.86749 10 8.475 10H12.275C12.8825 10 13.375 10.4925 13.375 11.1C13.375 11.7075 12.8825 12.2 12.275 12.2H8.475C7.86749 12.2 7.375 11.7075 7.375 11.1Z"
}, null, -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none"
}
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<path d=\"M3.375 4C3.375 3.44772 3.82272 3 4.375 3H13.4608C13.726 3 13.9804 3.10536 14.1679 3.29289L16.5886 5.71356C16.7723 5.89727 17.0203 6.00227 17.28 6.00633L24.3906 6.11743C24.9367 6.12596 25.375 6.57112 25.375 7.11731V24C25.375 24.5523 24.9273 25 24.375 25H4.375C3.82272 25 3.375 24.5523 3.375 24V4Z\" fill=\"#3F85FF\" data-v-03dc5ed8></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.375 11.1C7.375 10.4925 7.86749 10 8.475 10H12.275C12.8825 10 13.375 10.4925 13.375 11.1C13.375 11.7075 12.8825 12.2 12.275 12.2H8.475C7.86749 12.2 7.375 11.7075 7.375 11.1Z\" fill=\"#fff\" data-v-03dc5ed8></path><defs data-v-03dc5ed8><linearGradient id=\"paint0_linear_123_75001\" x1=\"3.375\" y1=\"3\" x2=\"27.7272\" y2=\"6.01762\" gradientUnits=\"userSpaceOnUse\" data-v-03dc5ed8><stop stop-color=\"#5C5252\" data-v-03dc5ed8></stop><stop offset=\"1\" stop-color=\"#332E2E\" data-v-03dc5ed8></stop></linearGradient></defs>", 3)
const _hoisted_48 = [
  _hoisted_45
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 6.25C5.55228 6.25 6 5.80228 6 5.25C6 4.69772 5.55228 4.25 5 4.25C4.44772 4.25 4 4.69772 4 5.25C4 5.80228 4.44772 6.25 5 6.25Z",
    fill: "#212429"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1 8.74978V12.75C1 13.8546 1.89543 14.75 3 14.75H13C14.1046 14.75 15 13.8546 15 12.75V3.25C15 2.14543 14.1046 1.25 13 1.25H3C1.89543 1.25 1 2.14543 1 3.25V8.74978ZM14 12.75V3.25C14 2.69772 13.5523 2.25 13 2.25L3 2.25C2.44772 2.25 2 2.69772 2 3.25V8.5158L2.26253 8.73458C3.5751 9.82839 5.47229 9.86035 6.82097 8.81138C8.12063 7.80054 9.85901 7.55509 11.3877 8.16658L11.6857 8.28576C11.9421 8.38832 12.0668 8.67931 11.9643 8.9357C11.8617 9.19209 11.5707 9.3168 11.3143 9.21424L11.0163 9.09505C9.81746 8.6155 8.45415 8.80799 7.43491 9.60074C5.84065 10.8407 3.64529 10.8961 2 9.78643V12.75C2 13.3023 2.44772 13.75 3 13.75H13C13.5523 13.75 14 13.3023 14 12.75Z",
    fill: "#212429"
  })
], -1))
const _hoisted_50 = {
  key: 0,
  fill: "none",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "28",
  height: "28"
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#61636F",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14 3C10.6863 3 8 5.68629 8 9C8 12.3137 10.6863 15 14 15C17.3137 15 20 12.3137 20 9C20 5.68629 17.3137 3 14 3ZM22 9C22 11.8557 20.5037 14.3619 18.2524 15.7775C22.1791 17.2759 25 20.7904 25 25C25 25.5523 24.5523 26 24 26C23.4477 26 23 25.5523 23 25C23 20.6782 19.0723 17 14 17C8.92772 17 5 20.6782 5 25C5 25.5523 4.55228 26 4 26C3.44772 26 3 25.5523 3 25C3 20.7904 5.82093 17.2759 9.74761 15.7775C7.49628 14.3619 6 11.8557 6 9C6 4.58172 9.58172 1 14 1C18.4183 1 22 4.58172 22 9ZM15 19C15 18.4477 14.5523 18 14 18C13.4477 18 13 18.4477 13 19V23C13 23.5523 13.4477 24 14 24C14.5523 24 15 23.5523 15 23V19Z"
}, null, -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  fill: "none",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#3F85FF",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M25 25C25 19.4772 20.0751 15 14 15C7.92487 15 3 19.4772 3 25C8.5 25 19.5 25 25 25Z"
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  fill: "#3F85FF",
  cx: "14",
  cy: "9",
  r: "8"
}, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M14 18V23"
}, null, -1))
const _hoisted_58 = [
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]

import { computed, onMounted, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useCinemaStore } from '@remote/store/cinema'
import { isLargeViewPort as checkLargeViewPort } from '@remote/utils/base'
import { useHeziFileStore } from '@remote/store/hezi-file'
import debounce from 'lodash/debounce'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showFooterBarRouteNames = ['home', 'cinema', 'heziFiles', 'album', 'me']
const hideFooterBarRouteNames =  ['login', 'deviceBind']

const store = useStore()
const router = useRouter()
const { refreshAllList: getCinemaStoreAllListData, getScrapeVersion, createScrapeTask } = useCinemaStore()
const { refreshFiles } = useHeziFileStore()
const currentPage = ref('')
const isLargeViewPort = ref(checkLargeViewPort())
const show = computed(() => {
  if (isLargeViewPort.value && !hideFooterBarRouteNames.includes(router.currentRoute.value.name as string)) return true
  return (
    showFooterBarRouteNames.includes(router.currentRoute.value.name as string) && !store.state.isSelect
  )
})

const handleOnResize = () => {
  isLargeViewPort.value = checkLargeViewPort()
}

onMounted( () => {
  window.addEventListener('resize', handleOnResize)
})

watchEffect(() => {
  if (show.value && router.currentRoute.value.name) {
    currentPage.value = (router.currentRoute.value.name) as string
  }
})

let prevPage = ''
let timer:NodeJS.Timeout

async function tabChange (page: string) {
  if (page === 'cinema') {
    const {initialized, hasUpdate} = await getScrapeVersion('tabChange')

    if (!initialized) {
      getCinemaStoreAllListData()
    }

    if (hasUpdate) {
      createScrapeTask('manual_btn_click')
    }

  } else if (page === 'heziFiles') {
    refreshFiles()
  }
  if (prevPage === 'cinema') {
    document.body.style.height = '100vh'
  }
}

const handleOnTabChange = debounce(tabChange, 2000)


const selectPage = (page:string) => {
  router.push({
    name: page,
    query: router.currentRoute.value.query,
  })

  timer && clearTimeout(timer)
  handleOnTabChange(page)
  prevPage = page
}


return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["item", { 'is-actived': currentPage.value === 'home' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectPage('home')))
          }, [
            (isLargeViewPort.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_8))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (currentPage.value === 'home')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_14))
                    : _createCommentVNode("", true),
                  (currentPage.value !== 'home')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18))
                    : _createCommentVNode("", true)
                ], 64)),
            _createElementVNode("p", {
              class: _normalizeClass({ actived: currentPage.value === 'home' })
            }, " 传输 ", 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass({ item: true, 'is-actived': currentPage.value === 'cinema' }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectPage('cinema')))
          }, [
            (isLargeViewPort.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_25))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (currentPage.value !== 'cinema')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_32))
                    : _createCommentVNode("", true),
                  (currentPage.value === 'cinema')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_35))
                    : _createCommentVNode("", true)
                ], 64)),
            _createElementVNode("p", {
              class: _normalizeClass({ 'actived': currentPage.value === 'cinema' })
            }, " 片库 ", 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item", { 'is-actived': currentPage.value === 'heziFiles' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (selectPage('heziFiles')))
          }, [
            (isLargeViewPort.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_39))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (currentPage.value !== 'heziFiles')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_40, _hoisted_43))
                    : _createCommentVNode("", true),
                  (currentPage.value === 'heziFiles')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _hoisted_48))
                    : _createCommentVNode("", true)
                ], 64)),
            _createElementVNode("p", {
              class: _normalizeClass({ actived: currentPage.value === 'heziFiles' })
            }, " 文件 ", 2)
          ], 2),
          (isLargeViewPort.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["item", { 'is-actived': currentPage.value === 'album' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (selectPage('album')))
              }, [
                _hoisted_49,
                _createElementVNode("p", {
                  class: _normalizeClass({ actived: currentPage.value === 'album' })
                }, " 相册 ", 2)
              ], 2))
            : _createCommentVNode("", true),
          (!isLargeViewPort.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (selectPage('me')))
              }, [
                (currentPage.value !== 'me')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_50, _hoisted_53))
                  : _createCommentVNode("", true),
                (currentPage.value === 'me')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_54, _hoisted_58))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: _normalizeClass({ actived: currentPage.value === 'me' })
                }, " 我的 ", 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})